import { render } from "./Directo_horaShow.vue?vue&type=template&id=5060b795"
import script from "./Directo_horaShow.vue?vue&type=script&lang=js"
export * from "./Directo_horaShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__